export default __webpack_public_path__ + "dcf93cd4c05e82db074ec209ee369849.svg";